module.exports = __webpack_public_path__ + "static/media/halugen-box-half-block2.4b8d4858.png";